import getSavedItems from "../savedLists/getSavedItems";
import receiveBoardDetails from "./receiveBoardDetails";
import { getUserIdentity } from "../../../modules/identity/actions";
import { beginAndCheckOnlineStatus } from "../savedLists/beginAndCheckOnlineStatus";

const attemptSetup = async dispatch => {
  if (!beginAndCheckOnlineStatus(dispatch)) {
    return [];
  }

  const getUserIdentityPromise = dispatch(getUserIdentity());
  const initialData = await dispatch(getSavedItems());

  if (initialData) {
    dispatch(receiveBoardDetails(initialData));
    if (initialData.itemCount === 0) {
      await getUserIdentityPromise;
    }
  }

  return [getUserIdentityPromise];
};

export default attemptSetup;
